import React from "react";

export const AppIcon = () => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm2 0v10h10V5H5zm2 2h6v1H7V7zm0 3h6v1H7v-1zm0 3h4v1H7v-1z" />
  </svg>
);

export const MailIcon = () => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 5.5A2.5 2.5 0 014.5 3h11A2.5 2.5 0 0118 5.5v9a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-9zm1.5 0v.217l6.5 4.55 6.5-4.55V5.5a1 1 0 00-1-1h-11a1 1 0 00-1 1zM16.5 7.4l-6.5 4.55L3.5 7.4V14.5a1 1 0 001 1h11a1 1 0 001-1V7.4z" />
  </svg>
);

export const GearIcon = () => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
    <path d="M11.423 3.006a1.43 1.43 0 00-2.846 0l-.216 1.08c-.604.13-1.173.355-1.696.657l-.98-.55a1.43 1.43 0 00-1.897.468L2.35 6.946a1.43 1.43 0 00.323 1.926l.89.675a5.98 5.98 0 000 1.906l-.89.675a1.43 1.43 0 00-.323 1.926l1.434 2.285a1.43 1.43 0 001.897.468l.98-.55c.523.302 1.092.527 1.696.657l.216 1.08a1.43 1.43 0 002.846 0l.216-1.08c.604-.13 1.173-.355 1.696-.657l.98.55a1.43 1.43 0 001.897-.468l1.434-2.285a1.43 1.43 0 00-.323-1.926l-.89-.675a5.98 5.98 0 000-1.906l.89-.675a1.43 1.43 0 00.323-1.926l-1.434-2.285a1.43 1.43 0 00-1.897-.468l-.98.55a5.98 5.98 0 00-1.696-.657l-.216-1.08zM10 13a3 3 0 110-6 3 3 0 010 6z" />
  </svg>
);

export const UploadIcon = () => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 2a.75.75 0 01.553.244l3.5 3.75a.75.75 0 01-1.106 1.012L10.75 5.54V13.5a.75.75 0 01-1.5 0V5.54L7.053 7.006a.75.75 0 01-1.106-1.012l3.5-3.75A.75.75 0 0110 2zM3.5 14.75a.75.75 0 011.5 0v.75h10v-.75a.75.75 0 011.5 0v.75A1.5 1.5 0 0115 17H5a1.5 1.5 0 01-1.5-1.5v-.75z" />
  </svg>
);

export const CheckIcon = () => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" />
  </svg>
);

export const ErrorIcon = () => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" />
  </svg>
);

export const InfoIcon = () => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v4a1 1 0 102 0V7zm-1 8a1 1 0 100-2 1 1 0 000 2z" />
  </svg>
);
